export enum RouteParamName {
  ResidentId = 'residentId'
}
